import { EntityModules } from 'core/constants';

export type Translation = {
  singular: string;
  plural: string;
  key: string;
  singularKey: string;
};

export const getEntityTranslation: Record<EntityModules, Translation> = {
  [EntityModules.Assets]: {
    plural: 'Assets',
    singular: 'Asset',
    key: 'assets',
    singularKey: 'asset',
  },
  [EntityModules.Sites]: {
    plural: 'Sites',
    singular: 'Site',
    key: 'sites',
    singularKey: 'site',
  },
  [EntityModules.Contacts]: {
    plural: 'Contacts',
    singular: 'Contact',
    key: 'contacts',
    singularKey: 'contact',
  },
  [EntityModules.RisksAssessments]: {
    plural: 'Risk Assessments',
    singular: 'Risk Assessment',
    key: 'riskAssessments',
    singularKey: 'riskAssessment',
  },
  [EntityModules.Events]: {
    plural: 'Events',
    singular: 'Event',
    key: 'events',
    singularKey: 'event',
  },
  [EntityModules.Documents]: {
    plural: 'Documents',
    singular: 'Document',
    key: 'documents',
    singularKey: 'document',
  },
  [EntityModules.Risks]: {
    plural: 'Risks',
    singular: 'Risk',
    key: 'risks',
    singularKey: 'risk',
  },
  [EntityModules.Audits]: {
    plural: 'Audits',
    singular: 'Audit',
    key: 'audits',
    singularKey: 'audit',
  },
  [EntityModules.Controls]: {
    plural: 'Controls',
    singular: 'Control',
    key: 'controls',
    singularKey: 'control',
  },
  [EntityModules.Hazards]: {
    plural: 'Hazards',
    singular: 'Hazard',
    key: 'hazards',
    singularKey: 'hazard',
  },
};
